import { render, staticRenderFns } from "./StoreVPNSidebar.vue?vue&type=template&id=83f3e1c4&scoped=true"
import script from "./StoreVPNSidebar.vue?vue&type=script&lang=js"
export * from "./StoreVPNSidebar.vue?vue&type=script&lang=js"
import style0 from "./StoreVPNSidebar.vue?vue&type=style&index=0&id=83f3e1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f3e1c4",
  null
  
)

export default component.exports